$(function() {
    var itemLimit = 5;
    var allItems = $('.govuk-list--spaced.expandable-list li');
    var filteredItems = allItems;

    function updateListDisplay(itemsToDisplay) {
        allItems.hide();
        itemsToDisplay.slice(0, itemLimit).show();

        var visibleCount = Math.min(itemLimit, itemsToDisplay.length);
        var totalCount = itemsToDisplay.length;

        $('#visible-count').text(visibleCount);
        $('#total-count').text(totalCount);

        var $singleMemberInfo = $('#single-member-info');
        var $multipleMembersInfo = $('#multiple-members-info');

        if (totalCount == 1) {
            $singleMemberInfo.show();
            $multipleMembersInfo.hide();
        } else {
            $singleMemberInfo.hide();
            $multipleMembersInfo.show();
        }

        var $viewAllLink = $('.view-all-link');
        var $viewFewerLink = $('.view-fewer-link');

        if (totalCount <= 5) {
            $viewAllLink.hide();
            $viewFewerLink.hide();
        } else if (itemLimit < totalCount) {
            $viewAllLink.show();
            $viewFewerLink.hide();
        } else {
            $viewAllLink.hide();
            $viewFewerLink.show();
        }
    }

    $(document).on('itemsFiltered', function(event, itemsToDisplay) {
        filteredItems = itemsToDisplay;
        itemLimit = 5;
        updateListDisplay(filteredItems);
    });

    $('.view-all-link').on('click', function(e) {
        e.preventDefault();
        itemLimit = filteredItems.length;
        updateListDisplay(filteredItems);
    });

    $('.view-fewer-link').on('click', function(e) {
        e.preventDefault();
        itemLimit = 5;
        updateListDisplay(filteredItems);
    });

    updateListDisplay(filteredItems);
});